export const nutrientSourcesDE = {
  Spirits: "Spirituosen",
  Wine: "Wein",
  Beer: "Bier",
  "Flaxseed oil": "Leinsamenöl",
  "Chia seeds": "Chia-Samen",
  "Hemp seeds": "Hanfsamen",
  "Canola oil": "Rapsöl",
  "Soybean oil": "Sojaöl",
  Edamame: "Edamame",
  "Navy beans": "Marinebohnen",
  Avocados: "Avocados",
  "Wholemeal bread": "Weizenvollkornbrot",
  Broccoli: "Brokkoli",
  Spinach: "Spinat",
  "Red meat": "Rotes Fleisch",
  "Organ meat": "Innereien",
  "Brussel sprouts": "Kohlsprossen",
  Tomatoes: "Tomaten",
  Peas: "Erbsen",
  "Brewer’s Yeast": "Hefe",
  "Beet root": "Rüben",
  Carrots: "Karotten",
  Sardines: "Sardinen",
  Salmon: "Lachs",
  Eggs: "Eier",
  Chicken: "Huhn",
  Pork: "Schweinefleisch",
  Milk: "Milch",
  Seaweed: "Seetang",
  "Leafy greens": "Blattgemüse",
  "Sesame seeds": "Sesamsamen",
  "Poppy seeds": "Mohn",
  "Celery seeds": "Sellerie Samen",
  Cheese: "Käse",
  Yogurt: "Joghurt",
  Beans: "Bohnen",
  Lentils: "Linsen",
  Almonds: "Mandeln",
  Whey: "Molke",
  "Spring greens": "Grünkohl",
  Shellfish: "Schalentiere",
  "Beef steak": "Rindersteak",
  "Full-fat yogurt": "Fettreiches Joghurt",
  Beef: "Rindfleisch",
  "Fatty fish": "Fetter Fisch",
  Cauliflower: "Karfiol",
  Oranges: "Orangen",
  Strawberries: "Erdbeeren",
  Legumes: "Hülsenfrüchte",
  Nuts: "Nüsse",
  Seeds: "Samen",
  Oils: "Öle",
  "Coffee beans": "Kaffeebohnen",
  Cacao: "Kakao",
  "Kola nuts": "Kolanüsse",
  "Green tea": "Grüner Tee",
  Guarana: "Guarana",
  "Yerba mate tea": "Mate-Tee",
  Oysters: "Austern",
  "Shiitake mushrooms": "Shiitake Pilze",
  Tofu: "Tofu",
  "Sweet potatoes": "Süßkartoffeln",
  "Cashew nuts": "Cashewkerne",
  "Dark leafy greens": "Dunkles Blattgemüse",
  Chickpeas: "Kichererbsen",
  Cocoa: "Kakao",
  "Pork chops": "Schweinekoteletts",
  "Chicken breast": "Hühnerbrust",
  Tuna: "Thunfisch",
  Oatmeal: "Haferflocken",
  "Low-fat yogurt": "Fettarmer Joghurt",
  "Sunflower seeds": "Sonnenblumenkerne",
  "Swiss cheese": "Schweizer Käse",
  Trout: "Forelle",
  Mussels: "Muscheln",
  Cod: "Kabeljau",
  "Fish roe": "Fischrogen",
  Herring: "Hering",
  Clams: "Venusmuscheln",
  Crab: "Krabbe",
  "Microalgae supplement": "Algenöl",
  "Forage fish": "Futterfisch",
  "Algal oil": "Algenöl",
  Walnuts: "Walnüsse",
  "Flax seeds": "Leinsamen",
  "Perilla oil": "Perillaöl",
  Berries: "Beeren",
  Popcorn: "Popcorn",
  "Whole grains": "Vollkorn",
  Apples: "Äpfel",
  "Dried fruits": "Getrocknete Früchte",
  Potatoes: "Kartoffeln",
  Asparagus: "Spargel",
  "Citrus fruit": "Zitrusfrucht",
  "Beef liver": "Rinderleber",
  "Wheat germ": "Weizenkeime",
  Papayas: "Papaya",
  Bananas: "Bananen",
  "Fortified grains": "Angereichertes Getreide",
  "Fruit juices": "Fruchtsäfte",
  "Soft drinks": "Limonade",
  Fruits: "Früchte",
  Honey: "Honig",
  "Fruit yogurt": "Fruchtjoghurt",
  "Apple pie": "Apfelkuchen",
  Sauces: "Saucen",
  "Salad dressing": "Salatsoße",
  Wheat: "Weizen",
  Barley: "Gerste",
  Rye: "Roggen",
  Triticale: "Triticale",
  Oats: "Hafer",
  Breads: "Brot",
  Cereals: "Getreide",
  Pasta: "Pasta",
  Rice: "Reis",
  "Chicken liver": "Hühnerleber",
  "Pumpkin seeds": "Kürbissamen",
  Quinoa: "Quinoa",
  Turkey: "Truthahn",
  Fish: "Fisch",
  "Red kidney beans": "Kidneybohnen",
  Butter: "Butter",
  "Ice-cream": "Eis",
  Cream: "Creme",
  "Sour cream": "Sauerrahm",
  "Crème fraiche": "Crème fraiche",
  Batter: "Teig",
  "Pastries ": "Gebäck",
  Kale: "Grünkohl",
  "Romaine lettuce": "Römersalat",
  Corn: "Mais",
  "Bell peppers": "Paprika",
  Parsley: "Petersilie",
  "Pistachio nuts": "Pistazien",
  Guavas: "Guaven",
  Watermelon: "Wassermelonen",
  Grapefruits: "Grapefruits",
  "Red bell peppers": "Rotem Paprika",
  Persimmon: "Kaki",
  "Red cabbage": "Rotkohl",
  Mangos: "Mangos",
  Mackerel: "Makrelen",
  Halibut: "Heilbutt",
  "Blue mussels": "Blauen Muscheln",
  "Brown rice": "braunem Reis",
  "Lima beans": "Limabohnen",
  Pineapple: "Ananas",
  "Ricotta cheese": "Ricotta-Käse",
  "Brazil nuts": "Paranuss",
  "White beans": "weiße Bohnen",
  Tea: "Tee",
  Coffee: "Kaffee",
  Juices: "Säfte",
  "Soya beverages": "Sojagetränke",
  "Beet greens": "Rübengrün",
  Rhubarb: "Rhabarber",
  "Swiss chard": "Schweizer Mangold",
  Chai: "Chai",
  Peanuts: "Erdnüssen",
  "Turnip greens": "Kohlrabi",
  "Star fruit": "Sternfrucht",
  "Dairy products": "Milchprodukten",
  "Butter milk": "Buttermilch",
  "Bottled coffee": "Kaffee in Flaschen",
  "Flavoured water": "Aromatisiertes Wasser",
  "Cereal bars": "Müsliriegel",
  "Cottage cheese": "Hüttenkäse",
  "Processed meats": "Verarbeitetes Fleisch",
  Hazelnuts: "Haselnüsse",
  "Rice bran": "Reiskleie",
  Soybeans: "Sojabohnen",
  "Kidney beans": "Kidneybohnen",
  "Sunflower oil": "Sonnenblumenöl",
  "Cottonseed oil": "Baumwollsamenöl",
  "Macadamia nuts": "Macadamianüsse",
  "Olive oil": "Olivenöl",
  "Tomato juice": "Tomatensaft",
  Mushrooms: "Pilze",
  Cucumbers: "Gurken",
  Zucchini: "Zucchini",
  Pumpkins: "Kürbisse",
  "Alcoholic drinks": "Alkoholische Getränke",
  Anchovies: "Sardellen",
  Scallops: "Jakobsmuscheln",
  Haddock: "Schellfisch",
  Bacon: "Speck",
  Veal: "Kalbfleisch",
  Venison: "Wildfleisch",
  Duck: "Ente",
  Ham: "Schinken",
  Lobster: "Hummer",
  Shrimp: "Garnelen",
  Coconut: "Kokosnüsse",
  "Palm kernel": "Palmkerne",
  Lamb: "Lamm",
  Mutton: "Hammelfleisch",
  "Cocoa butter": "Kakaobutter",
  "Shea butter": "Shea Butter",
  "Baked beans": "Gebackene Bohnen",
  "Table Salt": "Salz",
  "Cured ham": "Schinken",
  "Pickled gherkin": "Eingelegte Gurken",
  "Canned beans": "Dosenbohnen",
  "French bread": "Französisches Brot",
  "Teriyaki sauce": "Teriyaki Soße",
  Parmesan: "Parmesan",
  "Butternut squash": "Butternut-Kürbis",
  Cantaloupes: "Honigmelone",
  Apricots: "Aprikosen",
  "Sugar beets": "Zuckerrüben",
  "Sugar cane": "Zuckerrohr",
  "Sweet peas": "Süße Erbsen",
  Peaches: "Pfirsiche",
  "BBQ sauce": "Grillsoße",
  Ketchup: "Ketchup",
  "Spaghetti sauce": "Spaghettisoße",
  "Sport drinks": "Sportgetränke",
  "Chocolate milk": "Schokoladenmilch",
  Granola: "Granola",
  "Flavored coffee": "Aromatisierter Kaffee",
  "Iced tea": "Eistee",
  "Protein bars": "Proteinriegel",
  "Canned soup": "Dosensuppe",
  "Breakfast cereal": "Frühstücks Cerealien",
  "Canned fruit": "Dosenfrüchte",
  "Premade smoothies": "Trinkfertige Smoothies",
  "Sea buckthorn berries": "Sanddornbeeren",
  Olives: "Oliven",
  Peanut: "Erdnüsse",
  Pecans: "Pecannüsse",
  Rapeseed: "Raps",
  "Black currant seeds": "Samen der schwarzen Johannisbeere",
  Spirulina: "Spirulina",
  Chlorella: "Chlorella",
  "Fat-free milk": "Fettfreie Milch",
  "Sweet red peppers": "Süße rote Paprika",
  "Black-eyed peas": "Black Eyed Peas",
  Squash: "Kürbis",
  "Fortified oats": "Angereicherter Hafer",
  "Low-fat Milk": "Fettarme Milch",
  Liver: "Leber",
  "Soft cheese": "Weichkäse",
  "Kakadu plums": "Kakadu-Pflaumen",
  "Acerola cherries": "Acerolakirschen",
  "Rose hips": "Hagebutten",
  "Chilli peppers": "Chilischoten",
  "Sweet yellow peppers": "Süße gelbe Paprika",
  Blackcurrants: "Schwarze Johannisbeeren",
  Thyme: "Thymian",
  "Mustard spinach": "Senf Spinat",
  Kiwis: "Kiwis",
  Lemons: "Zitronen",
  Lychees: "Litschis",
  "American persimmons": "Amerikanische Persimonen",
  "Cod liver oil": "Lebertran",
  Soy: "Soja",
  "Oat milk": "Hafermilch",
  "Egg yolks": "Eigelb",
  "Cheddar cheese": "Cheddar-Käse",
  "Wheat germ oil": "Weizenkeimöl",
  "Safflower oil": "Distelöl",
  "Peanut butter": "Erdnussbutter",
  Abalone: "Abalone",
  "Collard greens": "Blattkohl",
  "Rainbow trout": "Regenbogenforellen",
  "Red sweet peppers": "Süße rote Paprika",
  Meat: "Fleisch",
  "Green beans": "Grüne Bohnen",
  Amaranth: "Amaranth",
  Millet: "Hirse",
  Arrowroot: "Pfeilwurz",
  Buckwheat: "Buchweizen",
  Sorghum: "Sorghum",
  Tapioca: "Tapioka",
  Soya: "Soja",
  "Almond milk": "Mandelmilch",
  "Soya milk": "Sojamilch",
  "Coconut milk": "Kokosnussmilch",
  Margarine: "Margarine",
  "Rice milk": "Reismilch",
};
